/**
 * Styled Components - Created by eduardo on 21/12/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 4px 7px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`

export const Colors = styled.div`
  display: flex;
  align-items: center;
`

interface OvalProps {
  color?: string
  selected?: boolean
}

export const Oval = styled.div`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  border: 1px solid
    ${({ color }: OvalProps) =>
      color && color.toLowerCase() !== '#ffffff' ? color : '#bebebe'};
  background-color: ${({ color }: OvalProps) => color || '#fff'};
  align-self: center;
  cursor: pointer;
`

export const OvalSelected = styled.div`
  height: 36px;
  width: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid
    ${({ selected }: OvalProps) => (selected ? '#2291dd' : '#fff')};
  margin-left: 8px;
  align-self: center;
  position: relative;
`

export const CheckIcon = styled(Icon)`
  position: absolute;
  top: -2px;
  right: -4px;
  background: #50a250;
  color: white;
  border-radius: 25px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/MobileAccessoryColor/styledComponents.tsx